import * as Yup from "yup";
import { getInitialValues } from "layouts/views/common/common";

const formField = {
  materialName: {
    name: "materialName",
    label: "Material Name",
    type: "text",
    errorMsg: "Material Name is required.",
    required: true,
    editable: false,
    maxLength: 50,
  },
  materialSize: {
    name: "materialSize",
    label: "Material Size",
    type: "text",
    errorMsg: "Material Name is required.",
    required: true,
    maxLength: 100,
  },
  barcode: {
    name: "barcode",
    label: "Barcode",
    type: "text",
    errorMsg: "Barcode is required.",
    required: true,
    maxLength: 20,
  },
  type: {
    name: "type",
    label: "Type",
    type: "select",
    errorMsg: "Type is required.",
    required: true,
  },
};

const { materialName, materialSize, barcode, type } = formField;

export const formRender = [[materialName], [materialSize], [barcode], [type]];

export const initialValues = getInitialValues(formField);

export const packagingMaterialValidation = Yup.object().shape({
  [materialName.name]: Yup.string().nullable().max(materialName.maxLength).required(materialName.errorMsg),
  [materialSize.name]: Yup.string().nullable().max(materialSize.maxLength).required(materialSize.errorMsg),
  [barcode.name]: Yup.string().nullable().max(barcode.maxLength).required(barcode.errorMsg),
  [type.name]: Yup.string().nullable().max(20).required(type.errorMsg),
});
